const state = () => ({
    addressDataComponents: [],
    updateId: null,
    version: 0
});

const getters = {
    getAddressDataComponentUpdateVersion: (state) => state.version,
    getAddressDataComponentUpdateId: (state) => state.updateId,
    getAddressDataComponents: (state) => state.addressDataComponents
}

const mutations = { 
    setAddressData(state, addressData)
    {
        const index = state.addressDataComponents.findIndex(data => data.updateId === addressData.updateId);
        if(index >= 0)
        {
            for (let key in addressData) {
                state.addressDataComponents[index][key] = addressData[key];
            }
        }
        else{
            state.addressDataComponents.push(addressData)
        }
        state.updateId = addressData.updateId;
        state.version++;
    }
}

const actions = {
    async setAddressDataAction(context, addressData)
    {
        context.commit('setAddressData', addressData)
    }
}

export default
{
    state, getters, mutations, actions
}